import { render, staticRenderFns } from "./admin_order_alarm_log.vue?vue&type=template&id=1a115c4a&scoped=true"
import script from "./admin_order_alarm_log.vue?vue&type=script&lang=js"
export * from "./admin_order_alarm_log.vue?vue&type=script&lang=js"
import style0 from "./admin_order_alarm_log.vue?vue&type=style&index=0&id=1a115c4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a115c4a",
  null
  
)

export default component.exports